import {useMemo, useState} from 'react';
import type {IListAllCompaniesQueryParams} from '../../../../react_query/companies/CompanyWithoutPagination';
import type {
  IKeyPartnersProps,
  IPartnerProps,
} from '../TnnCampaignCreationStepper';
import {
  createTnnPartnerQuery,
  TnnPartnerSelection,
} from './TnnPartnerSelection';
import {TNN_PARTNER_PRODUCTS} from './tnnPartnerUtils';

export const SelectPartners = ({
  title,
  keyType,
  partners,
  setPartners,
}: {
  title: string;
  keyType: IKeyPartnersProps;
  partners: IPartnerProps;
  setPartners: React.Dispatch<React.SetStateAction<IPartnerProps>>;
}) => {
  const product = TNN_PARTNER_PRODUCTS[keyType];
  const [query, setQuery] = useState<IListAllCompaniesQueryParams>(() =>
    createTnnPartnerQuery(product.backendProductValue),
  );
  const selectedCompanies = useMemo(
    () => partners[keyType].selected_companies,
    [keyType, partners],
  );

  return (
    <TnnPartnerSelection
      title={title}
      showTitle={false}
      productKey={keyType}
      backendProductValue={product.backendProductValue}
      selectedCompanies={selectedCompanies}
      onSelectedCompaniesChange={companies =>
        setPartners(prev => ({
          ...prev,
          [keyType]: {
            ...prev[keyType],
            selected_companies: companies,
          },
        }))
      }
      query={query}
      setQuery={setQuery}
    />
  );
};
